// Datos institucionales y de navegación. Todo lo que es texto editable del sitio
// vive en src/content/: cambiar una frase no debería obligar a tocar componentes
// ni la escena 3D.

export const SITE_URL = "https://yvyrai.lat";

export const brand = {
  name: "YvyrAI",
  // Firma que va siempre visible en el footer (guía, sección 5).
  signature: "Diseñado y entrenado en Asunción, Paraguay.",
  legal: "© 2026 YvyrAI",
  tagline: "Laboratorio de inteligencia artificial · Asunción, Paraguay",
} as const;

export const contact = {
  email: "admin@yvyrai.lat",
  whatsappNumber: "595972549945",
  whatsappDisplay: "+595 972 549945",
  x: "https://x.com/YvyrAI",
  instagram: "https://www.instagram.com/yvyr.ai",
  huggingFace: "https://huggingface.co/Manuel12435/YvyrAI-100m-Nano",
} as const;

export const paper = {
  // DOI de concepto: siempre resuelve a la última versión. Es el link principal.
  conceptDoi: "10.5281/zenodo.20533759",
  conceptDoiUrl: "https://doi.org/10.5281/zenodo.20533759",
} as const;

export type NavItem = { href: string; label: string };

export const mainNav: NavItem[] = [
  { href: "/investigacion", label: "Investigación" },
  { href: "/modelos", label: "Modelos" },
  { href: "/productos", label: "Productos" },
  { href: "/empresa", label: "Empresa" },
];

export const contactNavItem: NavItem = { href: "/contacto", label: "Contacto" };

export type FooterColumn = { title: string; links: NavItem[] };

export const footerColumns: FooterColumn[] = [
  {
    title: "Investigación",
    links: [
      { href: "/investigacion", label: "Investigación" },
      { href: "/paper", label: "Paper" },
      { href: "/auditoria", label: "Auditoría" },
    ],
  },
  {
    title: "Modelos",
    links: [
      { href: "/modelos/nano", label: "Nano" },
      { href: "/modelos", label: "Familia" },
    ],
  },
  {
    title: "Productos",
    links: [
      { href: "/productos#yvyra", label: "Yvyra" },
      { href: "/productos#tajy", label: "Tajy" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { href: "/empresa", label: "Empresa" },
      { href: "/equipo", label: "Equipo" },
      { href: "/prensa", label: "Prensa" },
      { href: "/faq", label: "Preguntas frecuentes" },
      { href: "/contacto", label: "Contacto" },
    ],
  },
  {
    title: "Legal",
    links: [
      { href: "/privacidad", label: "Privacidad" },
      { href: "/terminos", label: "Términos" },
    ],
  },
];

export type SocialLink = { href: string; label: string; kind: "x" | "instagram" | "huggingface" | "mail" };

export const socialLinks: SocialLink[] = [
  { href: contact.x, label: "YvyrAI en X", kind: "x" },
  { href: contact.instagram, label: "YvyrAI en Instagram", kind: "instagram" },
  { href: contact.huggingFace, label: "YvyrAI Nano en Hugging Face", kind: "huggingface" },
  { href: `mailto:${contact.email}`, label: `Mail: ${contact.email}`, kind: "mail" },
];
